import { NIKE_DOTCOM_HOST } from '@nike/ux-tread-dotcom-constants';
import { getDocumentLocation } from '@nike/ux-tread-dotcom-utils';
export var reduceShippingGroups = function reduceShippingGroups(sgs) {
  return sgs.reduce(function (arr, sg) {
    return arr.concat((sg === null || sg === void 0 ? void 0 : sg.commerceItems) || []);
  }, []);
};

/**
 * @name getPageUrl
 * @ignore
 * @description This function encapsulates the business logic around deriving a url for the purposes of passing
 * along per cart item added/edited. As there is a character limit on the values that can be stored we will also prefer
 * to save pathnames on prod-like urls where we can append the relative path to the prod url as needed.
 * @returns {string} a url or an empty string if the current page this function is called on is supposed to be excluded
 */
export function getPageUrl() {
  var location = getDocumentLocation();
  var origin = location.origin,
    pathname = location.pathname;

  // Determine the host via env variable or rely on constants module.
  // We should not rely on a default here so we will need to evaulate this practice.
  //TODO: MYBAG-3456 remove dependency and update module docs to include env variable requirement.
  var host = process.env.NEXT_PUBLIC_NIKE_DOTCOM_DOMAIN ? "https://www.".concat(process.env.NEXT_PUBLIC_NIKE_DOTCOM_DOMAIN) : NIKE_DOTCOM_HOST;
  var pageUrl = origin === host ? pathname : "".concat(origin).concat(pathname);
  return pageUrl;
}

/**
 * @name createItemData
 * @ignore
 * @description this utility function is meant to help consistently create the shape of the itemData field or return an
 * empty object to reliably map into items being passed into add or update cart functions
 * @returns {object} an object which can contain the itemData property meant for merging with cart items
 */
export var createItemData = function createItemData() {
  var url = getPageUrl();
  return url ? {
    itemData: {
      url: url
    }
  } : {};
};